<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import Details from "@/router/views/dts/dts-modal/details";
import Logs from "@/router/views/dts/dts-modal/logs";
import Rating from "@/router/views/dts/dts-modal/satisfactory-rating";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";
import TrackModal from "@/components/modals/track-modal.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";

export default {
  page: {
    title: "Office Tracks"
  },
  components: {
    Layout,
    PageHeader,
    Details,
    Logs,
    Rating,
    PrintOptions,
    RawData,
    TrackModal,
    AttachmentModal
  },
  data() {
    return {
      title: "Office Tracks",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Incoming Tracks",
          href: "/dts/incoming-tracks"
        },
        {
          text: "Office Tracks",
          active: true
        }
      ],
      modalTitle: "",
      tableData: [],
      selectAll: false,
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      perPageItem: 10,
      loading: false,
      uploadTitle: "",
      form: {
        deliveryUnitId: "",
        departmentId: "",
        title: "",
        description: "",
        destinationDepartmentId: "",
        destinationDepartment: [{ departmentName: "N/A", id: 0 }],
        destinationDeliveryUnitId: "",
        destinationDeliveryUnit: null,
        destinationCampus: null,
        processTypeId: "",
        processType: null,
        actionNeeded: "",
        actionType: null,
        documents: [],
        document: "",
        tracks: []
      },
      campusOptions: [],
      processTypeOptions: [],
      actionTypeOptions: [],
      formLoading: false,
      campusId: this.$store.state.data.selectedCampus.id,
      selectedDU: this.$store.state.data.selectedDU.id,
      selectedDepartment: this.$store.state.data.selectedDepartment.id,
      tabIndex: 0,
      tableSort: {
        sortBy: "",
        trackReverse: true,
        destinationReverse: false,
        processReverse: false,
        durationReverse: false,
        statusReverse: false
      }
    };
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      destinationDeliveryUnit: { required },
      destinationCampus: { required },
      processType: { required },
      actionType: { required },
      documents: { required }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.title) {
            if (item.title.toUpperCase().includes(this.filter.toUpperCase()))
              return item.title
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.description) {
            if (
              item.description.toUpperCase().includes(this.filter.toUpperCase())
            )
              return item.description
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.referenceNumber) {
            if (
              item.referenceNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            )
              return item.referenceNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    }
  },
  created() {
    this.getProcessType();
    this.getActionType();
    this.changeCampus();
  },
  methods: {
    changeCampus() {
      this.campusId = this.$store.state.data.selectedCampus.id;
      this.selectedDU = this.$store.state.data.selectedDU.id;
      this.selectedDepartment = this.$store.state.data.selectedDepartment.id;
      if (this.tabIndex == 0) this.getDraft();
      else if (this.tabIndex == 1) this.getInProcess();
      else if (this.tabIndex == 2) this.getProcessed();
    },
    sortData(sortBy) {
      if (sortBy == "track") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.trackReverse = !this.tableSort.trackReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.id < b.id) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.trackReverse) this.tableData.reverse();
      } else if (sortBy == "destination") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.destinationReverse = !this.tableSort
            .destinationReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.destinationDeliveryUnit.name < b.destinationDeliveryUnit.name) {
            return -1;
          }
          if (a.destinationDeliveryUnit.name > b.destinationDeliveryUnit.name) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.destinationReverse) this.tableData.reverse();
      } else if (sortBy == "processType") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.processReverse = !this.tableSort.processReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.processType.processName < b.processType.processName) {
            return -1;
          }
          if (a.processType.processName > b.processType.processName) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.processReverse) this.tableData.reverse();
      } else if (sortBy == "duration") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.durationReverse = !this.tableSort.durationReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData.forEach((item) => {
          item.processDuration = this.processDuration(item);
        });
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.processDuration < b.processDuration) {
            return -1;
          }
          if (a.processDuration > b.processDuration) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.durationReverse) this.tableData.reverse();
      } else if (sortBy == "status") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.statusReverse = !this.tableSort.statusReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.status < b.status) {
            return -1;
          }
          if (a.status > b.status) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.statusReverse) this.tableData.reverse();
      }
    },
    getDraft() {
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        destinationReverse: false,
        processReverse: false,
        durationReverse: false,
        statusReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetDraftTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting draft tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getInProcess() {
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        destinationReverse: false,
        processReverse: false,
        durationReverse: false,
        statusReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetInProcessTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.selectAll = false;
          res.data.forEach((item) => {
            item.selected = false;
          });
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting pending tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getProcessed() {
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        destinationReverse: false,
        processReverse: false,
        durationReverse: false,
        statusReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetCompletedTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.selectAll = false;
          res.data.forEach((item) => {
            item.selected = false;
          });
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting processed tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    async autoPostTrack(id){
      try{
        let {data: response} = await this.$store.dispatch("dtstrack/PostTrack", id);
        if(response.error) {
          this.showToast(response.errorMessage, "error");
          return { success: false }
        }
        let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
        dashboardData.incomingTracks = dashboardData.incomingTracks + 1;
        localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
        return {
          success: true,
          id: response.id
        }
      }catch(e){
        this.showToast('Something went wrong', "error");
        return { success: false }
      }
    },
    async uploadToServer(data){
        try{
            let response = await this.$store.dispatch("filemanager/UploadFile", data);
            if (response.data.error) {
                return { error: true, message: response.data.errorMessage };
            }
            return { error: false, data: response.data };
        }catch(e){
            return { error: true, message: "Something went wrong" };
        }
    },
    async uploadAttachments(files, trackNo){
      let errorDetails = [];
      for await(const file of files){
        file.id = trackNo;
        let response = await this.uploadToServer(file);
        if(response.error){
          file.error = true;
          file.errorMessage = response.message;
          errorDetails.push(file);
        }
      }
      if(errorDetails.length) {
        this.showToast("Some files were not uploaded. Please try again.", "error");
      }
    },
    async onSubmit(modalData) {
      if (modalData.actionType.type != "Others"){
        modalData.actionNeeded = modalData.actionType.type;
      }
      modalData.departmentId = 0;
      if (modalData.id) {
        await this.$store
          .dispatch("dtstrack/UpdateTrack", modalData)
          .then(async (res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            if (modalData.sendType == "update") {
              let index = this.tableData.findIndex((item) => item.id == modalData.id);
              this.tableData.splice(index, 1, modalData);
            } else {
              let postTrack = await this.autoPostTrack(modalData.id);
              if(postTrack.success == true){
                this.viewDetails(postTrack.id);
                let index = this.tableData.findIndex((item) => item.id == modalData.id);
                this.tableData.splice(index, 1);
              }
            }
            this.$bvModal.hide("modal-documentTrack");
            this.showToast("Successfully updated!", "success");
            if(modalData.attachments.length){
              this.uploadAttachments(modalData.attachments, modalData.id);
            }
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        await this.$store
          .dispatch("dtstrack/CreateTrack", modalData)
          .then(async (res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            if (modalData.tracks.length > 0) {
              var newTrack = res.data;
              this.$store
                .dispatch("dtstrack/MergeTrack", {
                  parentId: newTrack.id,
                  array: modalData.tracks
                })
                .then(async (res) => {
                  if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                  }
                  if (modalData.sendType == "create") {
                    this.tableData.unshift(newTrack);
                  } else {
                    let postTrack = await this.autoPostTrack(newTrack.id);
                    if(postTrack.success == true){
                      this.viewDetails(newTrack.id);
                    }
                  }
                  this.$bvModal.hide("modal-documentTrack");
                  this.showToast("Successfully created!", "success");
                });
            } else {
              if (modalData.sendType == "create") {
                this.tableData.unshift(res.data);
              } else {
                let postTrack = await this.autoPostTrack(res.data.id);
                if(postTrack.success == true){
                  this.viewDetails(postTrack.id);
                }
              }
              this.$bvModal.hide("modal-documentTrack");
              this.showToast("Successfully created!", "success");
            }
            if(modalData.attachments.length){
              this.uploadAttachments(modalData.attachments, res.data.id);
            }
          })
          .catch((err) => {
            console.log(err);
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    async createTrack() {
      this.$refs.trackModal.loading = true;
      this.modalTitle = "Create Track";
      this.$refs.trackModal.onReset();
      this.$bvModal.show("modal-documentTrack");
      this.$refs.trackModal.loading = false;
    },
    async updateTrack(props) {
      this.formLoading = true;
      this.modalTitle = "Update Track";
      this.$bvModal.show("modal-documentTrack");
      this.$refs.trackModal.updateData(props);
    },
    deleteTrack(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/DeleteTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    postTrack(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to send this track.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, send it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/PostTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let dashboardData = JSON.parse(
                localStorage.getItem("dashboardData")
              );
              dashboardData.incomingTracks = dashboardData.incomingTracks + 1;
              if (props.status == "RETURNED")
                dashboardData.returnedTracks = dashboardData.returnedTracks - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(dashboardData)
              );
              this.viewDetails(res.data.id);
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully sent", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be sent!", "error");
            });
        }
      });
    },
    unsendTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to unsend this track.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff9f43",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, unsend track!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/UnsendTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully unsent", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be unsent!", "error");
            });
        }
      });
    },
    viewDetails(id) {
      this.$refs.details.getData(id);
    },
    viewLogs(id) {
      console.log(id);
      this.$refs.logs.getData(id);
    },
    async viewAttachments(item) {
      this.uploadTitle = `${item.title} Attachments`;
      this.$refs.attachmentModal.setUploadOpt({
        type: `DTS Tracks`,
        placement: "left",
        folder: "DTS"
      });
      this.$refs.attachmentModal.getData(item.id);
      this.$bvModal.show("upload-attachment-modal");
    },
    trackRating(trackId) {
      this.$refs.rating.setRating(trackId, this.selectedDU);
    },
    saveRating(trackId) {
      var index = this.tableData.findIndex((item) => item.id == trackId);
      this.tableData[index].withRating = true;
    },
    async getProcessType() {
      await this.$store.dispatch("dtsprocesstype/GetProcessType").then((res) => {
        this.processTypeOptions = res.data.sort(function(a, b) {
          if (a.processName < b.processName) {
            return -1;
          }
          if (a.processName > b.processName) {
            return 1;
          }
          return 0;
        });
      });
    },
    async getActionType() {
      await this.$store.dispatch("dtsactiontype/GetActionType").then((res) => {
        this.actionTypeOptions = res.data.sort(function(a, b) {
          if (a.type < b.type) {
            return -1;
          }
          if (a.type > b.type) {
            return 1;
          }
          return 0;
        });
        this.actionTypeOptions.push({ type: "Others" });
      });
    },
    async refreshOptions() {
      this.$refs.trackModal.setLoading(true);
      await this.getProcessType();
      await this.getActionType();
      this.$refs.trackModal.setLoading(false);
    },
    resetSelected() {
      this.selectAll = false;
      this.tableData.forEach((item) => {
        item.selected = false;
      });
    },
    selectAllItems() {
      this.paginated.forEach((item) => {
        item.selected = false;
      });
      if (this.selectAll === true) {
        this.paginated.forEach((item) => {
          item.selected = true;
        });
      }
    },
    checkSelected(data) {
      var count = 0;
      data.forEach((item) => {
        if (item.selected) count++;
      });
      if (count === this.perPage) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    checkForSelected() {
      var count = 0;
      this.tableData.forEach((item) => {
        if (item.selected) count++;
      });
      if (count > 0) return true;
      else return false;
    },
    processDuration(props) {
      if (props.status != "RECEIVED") return 0;
      var dDate1 = new Date(props.dateTimeReceived);
      var dDate2 = new Date();
      var iWeeks,
        iDateDiff,
        iAdjust = 0;
      if (dDate2 < dDate1) return -1;
      var iWeekday1 = dDate1.getDay();
      var iWeekday2 = dDate2.getDay();
      iWeekday1 = iWeekday1 == 0 ? 7 : iWeekday1;
      iWeekday2 = iWeekday2 == 0 ? 7 : iWeekday2;
      if (iWeekday1 > 5 && iWeekday2 > 5) iAdjust = 1;
      iWeekday1 = iWeekday1 > 5 ? 5 : iWeekday1;
      iWeekday2 = iWeekday2 > 5 ? 5 : iWeekday2;

      iWeeks = Math.floor((dDate2.getTime() - dDate1.getTime()) / 604800000);

      if (iWeekday1 <= iWeekday2) {
        iDateDiff = iWeeks * 5 + (iWeekday2 - iWeekday1);
      } else {
        iDateDiff = (iWeeks + 1) * 5 - (iWeekday1 - iWeekday2);
      }

      iDateDiff -= iAdjust;

      return iDateDiff;
    },
    expectedCompletion(props) {
      var startDate = new Date(props.dateTimeReceived);
      var endDate = "",
        noOfDaysToAdd = props.processType.estimatedWorkingDays,
        count = 0;
      while (count < noOfDaysToAdd) {
        endDate = new Date(startDate.setDate(startDate.getDate() + 1));
        if (endDate.getDay() != 0 && endDate.getDay() != 6) {
          count++;
        }
      }
      return endDate;
    },
    async printTrackingReport() {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      this.tableData.forEach((item) => {
        if (item.selected) body.push({ id: item.id });
      });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async printSingleTrackingReport(id) {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      body.push({ id: id });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    formatDUs(deliveryUnits, duName) {
      if(deliveryUnits.length == 0) return duName || "N/A";
      var duString = "";
      deliveryUnits.forEach((du) => {
        duString += (du.deliveryUnit || du.name) + "<br />";
      });
      return duString.slice(0, -6);
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <TrackModal 
      ref="trackModal"
      :modalTitle="modalTitle"
      selectedSendAs="office"
      :processTypeOptions="processTypeOptions"
      :actionTypeOptions="actionTypeOptions"
      @refreshOptions="refreshOptions" 
      @submit="onSubmit"
    />
    <!-- Main -->
    <div class="position-relative">
      <div
        v-if="tabIndex == 0"
        class="text-right position-absolute"
        style="right: 0"
      >
        <button
          type="button"
          @click="createTrack()"
          class="btn btn-sm btn-success d-flex align-items-center ms-1"
        >
          <i class="bx bx-plus fs-6 me-1"></i>Create Track
        </button>
      </div>
      <b-tabs
        content-class="text-muted"
        v-model="tabIndex"
        nav-class="nav-tabs-custom"
      >
        <!-- Draft -->
        <b-tab
          @click="
            getDraft();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Draft</span>
          </template>
          <div v-if="tabIndex == 0" class="py-2" style="min-width: 950px">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">List of Tracks</h5>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      @keyup="currentPage = 1"
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                tracks matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div
                      class="col-6 cursor-pointer"
                      @click="sortData('track')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'track' }"
                        >Process Track<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.trackReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-3 cursor-pointer"
                      @click="sortData('destination')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'destination'
                        }"
                        >Destination<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.destinationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('status')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'status' }"
                        >Status<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.statusReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div class="col-1 text-end">
                      <b>Actions</b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-6">
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-green"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewAttachments(x)"
                              >
                                View Attachments
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div 
                          v-if="!x.destinationDepartment || (x.destinationDepartment.length && x.destinationDepartment[0].id == 0)" 
                          v-html="formatDUs(x.trackDestinationDeliveryUnits,  x.destinationDeliveryUnit.name)">
                        </div>
                        <div v-else>
                          {{ x.destinationDepartment.departmentName }} ({{
                            x.destinationDeliveryUnit.name
                          }})
                        </div>
                      </div>
                      <div class="col-2">
                        <div v-if="x.status == 'DRAFT'">
                          <span class="text-info">CREATED</span> on
                          {{ formatDateWithTime(new Date(x.dateTimeCreated)) }}
                        </div>
                        <div v-if="x.status == 'RETURNED'">
                          <span class="text-warning">{{ x.status }}</span> on
                          {{ formatDateWithTime(new Date(x.dateTimePosted)) }}
                        </div>
                      </div>
                      <div class="col-1">
                        <div class="d-flex justify-content-end">
                          <i
                            class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                            :id="`draft-popover-${x.id}`"
                            tabindex="0"
                          ></i>
                          <b-popover
                            :target="`draft-popover-${x.id}`"
                            triggers="click blur"
                            placement="leftbottom"
                            variant="secondary"
                            custom-class="p-0"
                          >
                            <b-list-group class="w-100 fit">
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-success"
                                @click="postTrack(x)"
                                ><i class="bx bx-send font-size-18 me-1"></i
                                >Send Track</b-list-group-item
                              >
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-info"
                                @click="updateTrack(x)"
                                ><i class="bx bx-edit font-size-18 me-1"></i
                                >Update Track</b-list-group-item
                              >
                              <b-list-group-item
                                v-if="x.status == 'DRAFT'"
                                button
                                action
                                class="d-flex align-items-center text-danger"
                                @click="deleteTrack(x)"
                                ><i class="bx bx-trash font-size-18 me-1"></i
                                >Delete Track</b-list-group-item
                              >
                            </b-list-group>
                          </b-popover>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- In-Process -->
        <b-tab
          @click="
            getInProcess();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">In-Process</span>
          </template>
          <div v-if="tabIndex == 1" class="py-2" style="min-width: 950px">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">List of Tracks</h5>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      @keyup="
                        resetSelected();
                        currentPage = 1;
                      "
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                tracks matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <div class="d-flex align-items-center mb-1">
                <div class="p-1 pe-0">
                  <div
                    class="form-check form-checkbox-outline form-check-success"
                  >
                    <input
                      type="checkbox"
                      id="checkbox-all"
                      checked="checked"
                      class="form-check-input"
                      @change="selectAllItems()"
                      v-model="selectAll"
                    />
                    <label for="checkbox-all" class="form-check-label">
                      Select All
                    </label>
                  </div>
                </div>
                <div class="ms-3">|</div>
                <transition name="slide">
                  <div
                    class="d-flex align-items-center"
                    v-if="checkForSelected()"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-purple ms-3 d-flex align-items-center"
                      @click="printTrackingReport()"
                    >
                      <i class="bx bx-printer fs-6 me-1"></i>
                      Print Tracking Report
                    </button>
                  </div>
                </transition>
              </div>
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div
                      class="col-4 cursor-pointer"
                      @click="sortData('track')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'track' }"
                        >Process Track<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.trackReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('destination')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'destination'
                        }"
                        >Destination<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.destinationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('processType')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'processType'
                        }"
                        >Process Type<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.processReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('duration')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'duration'
                        }"
                        >Duration<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.durationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('status')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'status' }"
                        >Status<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.statusReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-4">
                        <div
                          class="form-check form-checkbox-outline form-check-success"
                        >
                          <input
                            type="checkbox"
                            :id="`selected-${x.id}`"
                            class="form-check-input"
                            @change="checkSelected(paginated)"
                            v-model="x.selected"
                          />
                          <label
                            :for="`selected-${x.id}`"
                            class="form-check-label"
                          >
                            {{ x.referenceNumber }}
                          </label>
                        </div>
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-green"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewAttachments(x)"
                              >
                                View Attachments
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div 
                          v-if="!x.destinationDepartment" 
                          v-html="formatDUs(x.trackDestinationDeliveryUnits,  x.destinationDeliveryUnit.name)">
                        </div>
                        <div v-else>
                          {{ x.destinationDepartment.departmentName }} ({{
                            x.destinationDeliveryUnit.name
                          }})
                        </div>
                      </div>
                      <div class="col-2">
                        <div>
                          {{ x.processType.processName }}
                        </div>
                        <small>
                          {{ x.processType.easeOfDoingBusinessType }}
                        </small>
                      </div>
                      <div class="col-2">
                        <div v-if="x.status == 'RECEIVED'">
                          <div>
                            Days since received: (
                            <b
                              :class="
                                x.processType.estimatedWorkingDays <
                                processDuration(x)
                                  ? 'text-danger'
                                  : x.processType.daysToRemindOfficeProcessor <
                                    processDuration(x)
                                  ? 'text-warning'
                                  : 'text-success'
                              "
                            >
                              {{ processDuration(x) }} </b
                            >)
                          </div>
                          <div v-if="x.note">
                            <div class="d-flex gap-1">
                              <div><small>Notes: </small></div>
                              <div>
                                <small>{{ x.note }}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="text-secondary">N/A</div>
                      </div>
                      <div class="col-2">
                        <div v-if="x.status == 'PENDING'">
                          <div>
                            <span class="text-info">SENT</span> on
                            {{ formatDate(new Date(x.dateTimePosted)) }}
                          </div>
                          <button
                            type="button"
                            @click="unsendTrack(x)"
                            class="btn btn-sm btn-warning d-flex align-items-center mt-2"
                          >
                            <i class="bx bx-undo fs-6 me-1"></i>Unsend Track
                          </button>
                        </div>
                        <div v-if="x.status == 'RETURNED'">
                          <span class="text-warning">{{ x.status }}</span> on
                          {{ formatDate(new Date(x.dateTimePosted)) }}
                        </div>
                        <div v-if="x.status == 'RECEIVED'">
                          <div class="font-size-12">
                            <span class="text-pink">{{ x.status }}</span> on
                            {{ formatDate(new Date(x.dateTimeReceived)) }}
                          </div>
                          <div class="font-size-12">
                            To be <span class="text-purple">COMPLETED</span> on
                            {{ formatDate(new Date(expectedCompletion(x))) }}
                          </div>
                        </div>
                        <div v-if="x.status == 'COMPLETED'">
                          Currently <span class="text-purple">FORWARDED</span>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  @click="checkSelected(paginated)"
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Processed -->
        <b-tab
          @click="
            getProcessed();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Processed</span>
          </template>
          <div v-if="tabIndex == 2" class="py-2" style="min-width: 950px">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">List of Tracks</h5>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      @keyup="
                        resetSelected();
                        currentPage = 1;
                      "
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                tracks matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <div class="d-flex align-items-center mb-1">
                <div class="p-1 pe-0">
                  <div
                    class="form-check form-checkbox-outline form-check-success"
                  >
                    <input
                      type="checkbox"
                      id="checkbox-all"
                      checked="checked"
                      class="form-check-input"
                      @change="selectAllItems()"
                      v-model="selectAll"
                    />
                    <label for="checkbox-all" class="form-check-label">
                      Select All
                    </label>
                  </div>
                </div>
                <div class="ms-3">|</div>
                <transition name="slide">
                  <div
                    class="d-flex align-items-center"
                    v-if="checkForSelected()"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-purple ms-3 d-flex align-items-center"
                      @click="printTrackingReport()"
                    >
                      <i class="bx bx-printer fs-6 me-1"></i>
                      Print Tracking Report
                    </button>
                  </div>
                </transition>
              </div>
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div
                      class="col-7 cursor-pointer"
                      @click="sortData('track')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'track' }"
                        >Process Track<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.trackReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-3 cursor-pointer"
                      @click="sortData('destination')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'destination'
                        }"
                        >Destination<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.destinationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('status')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'status' }"
                        >Status<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.statusReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-7">
                        <div
                          class="form-check form-checkbox-outline form-check-success"
                        >
                          <input
                            type="checkbox"
                            :id="`selected-${x.id}`"
                            class="form-check-input"
                            @change="checkSelected(paginated)"
                            v-model="x.selected"
                          />
                          <label
                            :for="`selected-${x.id}`"
                            class="form-check-label"
                          >
                            {{ x.referenceNumber }}
                          </label>
                        </div>
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-green"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewAttachments(x)"
                              >
                                View Attachments
                              </a>
                            </small>
                          </div>
                          <span v-if="!x.withRating" class="mx-2">|</span>
                          <div v-if="!x.withRating">
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-pink"
                                @click="trackRating(x.id)"
                              >
                                Rate Track
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div 
                          v-if="!x.destinationDepartment" 
                          v-html="formatDUs(x.trackDestinationDeliveryUnits,  x.destinationDeliveryUnit.name)">
                        </div>
                        <div v-else>
                          {{ x.destinationDepartment.departmentName }} ({{
                            x.destinationDeliveryUnit.name
                          }})
                        </div>
                      </div>
                      <div class="col-2">
                        <div>
                          <span class="text-success">PROCESSED</span> on
                          {{ formatDateWithTime(new Date(x.actionDateTime)) }}
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  @click="checkSelected(paginated)"
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <Details
      user="office"
      @updateTrack="updateTrack($event)"
      @postTrack="postTrack($event)"
      @unsendTrack="unsendTrack($event)"
      @deleteTrack="deleteTrack($event)"
      @printTrackingReport="printSingleTrackingReport($event)"
      ref="details"
    ></Details>
    <Logs @viewDetails="viewDetails($event)" ref="logs"></Logs>
    <Rating ref="rating" @saveRating="saveRating($event)"></Rating>
    <print-options ref="printOpt"></print-options>
    <attachment-modal :wActions="tabIndex == 0" :title="uploadTitle" ref="attachmentModal"></attachment-modal>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.multiselect__option--group {
  padding-top: 16px;
  padding-bottom: 0;
  background: #2a3042 !important;
  color: #bfc8e2 !important;
  font-weight: bold !important;
  font-size: medium !important;
}
</style>